import React, { Component } from 'react'

import { Edit } from 'components/detail';
import { SimpleForm,maxLength } from 'components/form';
import { connect } from 'react-redux'
import { change as changeAction } from 'redux-form'


import { TextInput, DatetimeInput, SelectInput } from 'components/input';

import {
  DisabledInputOptions, InputOptions,
} from 'util/constants';

import * as urls from './urls';
import * as utils from './utils';

class PopupNotificationEditBase extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const { formInitial, editable } = props;
    const formDataRecord = new FormData();
    const formKeys = ['notification_type', 'description', 'en_title', 'local_title', 'en_body', 'local_body', 'en_hyperlink_name', 'local_hyperlink_name', 'hyperlink_link'];
    if (editable) {
      for (const key of formKeys) {
        (formInitial[key] !== record[key]) && formDataRecord.append(key, record[key]);
      }
      (new Date(formInitial['effective_time']).getTime() !== new Date(record['effective_time']).getTime()) && formDataRecord.append('effective_time', record['effective_time']);
    } 
    (formInitial['valid'] !== record['valid']) && formDataRecord.append('valid', record['valid']);
    props.crudUpdate(props.resource, props.id, formDataRecord, props.data, props.editBackendPath, basePath);
  };

  render() {
    return (
      <Edit
        editBackendPath={urls.popupNotificationEditBackendPath}
        {...this.props}
        handleSubmit={this.handleSubmit}
      >
        <SimpleForm>
          <SelectInput
            source='notification_type'
            label='Notification type'
            choices={utils.POPUP_NOTIFICATION_TYPE_CHOICES}
            isRequired={true}
            disabled={!this.props.editable}
          />
          <TextInput source='description' label='Description' validators={[maxLength(50)]} isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <TextInput source='en_title' label='EN Title' validators={[maxLength(50)]} isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <TextInput source='local_title' label='TH Title' validators={[maxLength(50)]} isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <TextInput source='en_body' label='EN Body' validators={[maxLength(255)]} isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <TextInput source='local_body' label='TH Body' validators={[maxLength(255)]} isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <TextInput source='en_hyperlink_name' label='EN Hyperlinks Name' validators={[maxLength(50)]} isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <TextInput source='local_hyperlink_name' label='TH Hyperlinks Name' validators={[maxLength(50)]} isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <TextInput source='hyperlink_link' label='Hyperlinks Link' isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} />
          <DatetimeInput source='effective_time' label='Effective Date' isRequired={true} options={this.props.editable ? InputOptions : DisabledInputOptions} optionsTime={this.props.editable ? InputOptions : DisabledInputOptions}/>
          <SelectInput
            source='valid'
            label='Status'
            choices={utils.POPUP_STATUS_DISPLAY_CHOICES}
            options={InputOptions}
            optionValue={'enabled'}
          />
      </SimpleForm>
      </Edit>
    )
  }
};

export const PopupNotificationEdit = connect(
  (state) => {
    return {
      formInitial: ((state.form['record-form'] || {}).initial || {}),
      editable: (((state.form['record-form'] || {}).initial || {}).send_status === utils.POPUP_NOTIFICATION_STATUS_PENDING)
    }
  },
  {
    change: changeAction,
  }
)(PopupNotificationEditBase);


// WEBPACK FOOTER //
// ./src/routes/notification/PopupNotificationEdit.js